import { useEffect, useRef, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

export function usePoll(path, intervalMs = 1000) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const timer = useRef(null);
  useEffect(() => {
    let alive = true;
    const tick = async () => {
      try {
        const r = await axios.get(`${API}${path}`);
        if (alive) { setData(r.data); setErr(null); }
      } catch (e) {
        if (alive) setErr(e.message || String(e));
      }
    };
    tick();
    timer.current = setInterval(tick, intervalMs);
    return () => { alive = false; clearInterval(timer.current); };
  }, [path, intervalMs]);
  return { data, err };
}

export const updateConfig = (patch) => axios.patch(`${API}/config`, patch);
export const startBot = () => axios.post(`${API}/start`);
export const stopBot = () => axios.post(`${API}/stop`);
export const setMode = (env) => axios.post(`${API}/mode`, { env });

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join("; ");
  return d || e?.message || "Request failed";
};

export const usd = (x) => (x == null ? "—" : `${x < 0 ? "-" : ""}$${Math.abs(Number(x)).toFixed(2)}`);
export const pct = (x) => (x == null ? "—" : `${Number(x).toFixed(1)}%`);
export const ptTime = (iso) => (iso ? new Date(iso).toLocaleString("en-US", { timeZone: "America/Los_Angeles", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false }) : "—");
export const mmss = (s) => (s == null ? "—" : `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}`);
